import { getApiUrl } from "./index";

export const onGetProducts = async (planType?: "single" | "monthly" | "yearly") => {
  const url = getApiUrl();

  console.log(url, "urlurl dft");

  const response = await fetch(`${url}/api/order/product?planType=${planType || "single,monthly,yearly"}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.json();
};

export const onGetUserPoint = async () => {
  const url = getApiUrl();

  const response = await fetch(`${url}/api/userPoint`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("fellou.id_token")}`,
    },
  });
  return response.json();
};

export const onCreateOrder = async (productId: string, returnUrl: string) => {
  const baseUrl = getApiUrl();

  const response = await fetch(`${baseUrl}/api/order/create`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("fellou.id_token")}`,
    },
    body: JSON.stringify({ productId: productId, returnUrl: returnUrl }),
  });
  return response.json();
};
